import { Box, Button, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useLocation, useNavigate } from 'react-router-dom';

function AssessmentResults() {
    const navigate = useNavigate()
    const location = useLocation()

    const [detail, setDetail] = useState(null)

    useEffect(() => {
        console.log(location.state)
        setDetail(location.state.data)
    }, [])

    return (
        <Box sx={{
            display: "grid",
            gridGap: "20px"
        }}>
            <Box
                sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}
            >
                แบบประเมินสุขภาพใจ
            </Box>

            <Box sx={{
                padding: '0 20px',
                fontSize: '16px',
                display: 'grid',
                gridGap: '10px',
                "@media (max-width: 800px)": {
                    padding: '0',
                },
            }}>
                <Box sx={{
                    fontWeight: 600,
                    "@media (max-width: 800px)": {
                        textAlign: 'center'
                    },
                }}>ผลการประเมิน</Box>

                {detail !== null ?
                    <React.Fragment>
                        <>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gridGap: '10px',
                                color: '#478F96',
                                fontWeight: '600'
                            }} >
                                <FiberManualRecordIcon sx={{ fontSize: '10px' }} />
                                <Box>แบบประเมินพลังใจ (RQ)</Box>
                            </Box>
                            <Box sx={{
                                border: '1px solid #AEB4DD',
                                borderRadius: '10px',
                                padding: '20px',
                                fontSize: '16px',
                                "@media (max-width: 800px)": {
                                    fontSize: '12px',
                                    padding: '10px',
                                },
                            }}>
                                <Box sx={{
                                    fontWeight: '600',
                                    fontSize: '20px',
                                    "@media (max-width: 800px)": {
                                        fontSize: '14px',
                                    },
                                }}>{detail?.['result_rq']?.['level']}</Box>
                                <Box>{detail?.['result_rq']?.['recommend_detail']}</Box>
                            </Box>
                        </>

                        <>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gridGap: '10px',
                                color: '#478F96',
                                fontWeight: '600'
                            }} >
                                <FiberManualRecordIcon sx={{ fontSize: '10px' }} />
                                <Box>แบบประเมินอาการเหนื่อยล้า หมดไฟ (Burnout)</Box>
                            </Box>
                            <Box sx={{
                                border: '1px solid #AEB4DD',
                                borderRadius: '10px',
                                padding: '20px',
                                fontSize: '16px',
                                "@media (max-width: 800px)": {
                                    fontSize: '12px',
                                    padding: '10px',
                                },
                            }}>
                                <Box sx={{
                                    fontWeight: '600',
                                    fontSize: '20px',
                                    "@media (max-width: 800px)": {
                                        fontSize: '14px',
                                    },
                                }}>{detail?.['result_burnout']?.['level']}</Box>
                                <Box>{detail?.['result_burnout']?.['recommend_detail']}</Box>
                            </Box>
                        </>

                        <>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gridGap: '10px',
                                color: '#478F96',
                                fontWeight: '600'
                            }} >
                                <FiberManualRecordIcon sx={{ fontSize: '10px' }} />
                                <Box>แบบประเมินความเครียด 5 ข้อ (ST- 5)</Box>
                            </Box>
                            <Box sx={{
                                border: '1px solid #AEB4DD',
                                borderRadius: '10px',
                                padding: '20px',
                                fontSize: '16px',
                                "@media (max-width: 800px)": {
                                    fontSize: '12px',
                                    padding: '10px',
                                },
                            }}>
                                <Box sx={{
                                    fontWeight: '600',
                                    fontSize: '20px',
                                    "@media (max-width: 800px)": {
                                        fontSize: '14px',
                                    },
                                }}>{detail?.['result_st5']?.['level']}</Box>
                                <Box>{detail?.['result_st5']?.['recommend_detail']}</Box>
                            </Box>
                        </>
                        {detail['result_9q'] &&
                            <>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gridGap: '10px',
                                    color: '#478F96',
                                    fontWeight: '600'
                                }} >
                                    <FiberManualRecordIcon sx={{ fontSize: '10px' }} />
                                    <Box>แบบคัดกรองโรคซึมเศร้าด้วย 9 คำถาม (9Q)</Box>
                                </Box>
                                <Box sx={{
                                    border: '1px solid #AEB4DD',
                                    borderRadius: '10px',
                                    padding: '20px',
                                    fontSize: '16px',
                                    "@media (max-width: 800px)": {
                                        fontSize: '12px',
                                        padding: '10px',
                                    },
                                }}>
                                    <Box sx={{
                                        fontWeight: '600',
                                        fontSize: '20px',
                                        "@media (max-width: 800px)": {
                                            fontSize: '14px',
                                        },
                                    }}>{detail?.['result_9q']?.['level']}</Box>
                                    <Box>{detail?.['result_9q']?.['recommend_detail']}</Box>
                                </Box>
                            </>
                        }
                    </React.Fragment>
                    :
                    <Box sx={{textAlign: 'center'}} >ไม่พบข้อมูล</Box>
                }
            </Box>

            <Box>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center'
                }}>
                    <Button
                        variant="contained"
                        sx={{
                            width: "150px",
                            "@media (max-width: 800px)": {
                                width: "150px",
                            },
                        }}
                        onClick={() => navigate('/mentalHealthAssessment')}
                    >กลับหน้าหลัก</Button>
                </Box>
            </Box>
        </Box >
    )
}

export default AssessmentResults
